import Vue from "vue"
import Vuex from "vuex"

import boletosAvulsosStore from "./boletosAvulsosStore.js";
import bairrosStore from "./bairrosStore.js";
import cidadesStore from "./cidadesStore.js";
import caracteristicasStore from "./caracteristicasStore";
import imobiliariasStore from "./imobiliariasStore";

import loginStore from "../modules/login/loginStore.js";
import dashboardStore from "../modules/dashboard/dashboardStore.js";
import caixaStore from "../modules/caixa/caixaStore.js";

import alugueisImoveisStore from "../modules/alugueis/imoveis/imoveisStore.js";
import alugueisClientesStore from "../modules/alugueis/clientes/clientesStore.js";
import alugueisContratosStore from "../modules/alugueis/contratos/contratosStore.js";
import alugueisRelatoriosStore from "../modules/alugueis/relatorios/relatoriosStore.js";

import baixasStore from "../modules/alugueis/baixas/baixasStore.js";
import remessasStore from "../modules/alugueis/remessasRegistros/remessas/remessasStore.js";
import registrosApiStore from "../modules/alugueis/remessasRegistros/registrosApi/registro/registrosApiStore.js"
import controleRegistroApiStore from "../modules/alugueis/remessasRegistros/registrosApi/controle/controleRegistroApiStore.js"
import dimobStore from "../modules/alugueis/dimob/dimobStore.js";

import parceriasStore from "../modules/parcerias/parceriasStore.js";

import vendasImoveisStore from "../modules/vendas/imoveis/imoveisStore.js";
import vendasClientesStore from "../modules/vendas/clientes/clientesStore.js";
import vendasContratosStore from "../modules/vendas/contratos/contratosStore.js";
import vendasRelatoriosStore from "../modules/vendas/relatorios/relatoriosStore.js";
import vendasAtendimentosStore from "../modules/vendas/atendimentos/atendimentosStore.js";

import contasReceberStore from "../modules/financeiro/contasReceber/contasReceberStore.js";
import contasPagarStore from "../modules/financeiro/contasPagar/contasPagarStore.js";
import fornecedoresStore from "../modules/financeiro/fornecedores/fornecedoresStore.js";
import planosContaStore from "../modules/financeiro/planosConta/planosContaStore.js";
import gruposContaStore from "../modules/financeiro/gruposConta/gruposContaStore.js";
import financeiroRelatoriosStore from "../modules/financeiro/relatorios/relatoriosStore.js";
import subGrupoPlanoContasStore from "../modules/financeiro/subGrupoConta/subGrupoPlanoContasStore.js"
import tipoContasStore from "../modules/financeiro/tiposConta/tipoContasStore.js";
import remessasBancariasFinanceiro from "../modules/financeiro/remessasBancariasFinanceiro/remessaBancariaFinanceiroStore.js"
import retornoBancarioFinanceiro from '../modules/financeiro/baixaRetornoBancario/retornoBancarioFinanceiroStore.js'

import usuariosStore from "../modules/configuracoes/usuarios/usuariosStore.js";
import condominiosStore from "../modules/configuracoes/condominios/condominiosStore.js";
import administradorasStore from "../modules/configuracoes/administradoras/administradorasStore.js";
import contasBancariasStore from "../modules/configuracoes/contas_bancarias/contasBancariasStore.js";
import placasStore from "../modules/configuracoes/placas/placasStore.js";
import parametrosStore from "../modules/configuracoes/parametros/parametrosStore.js";
import logsAcessoStore from "../modules/configuracoes/logs_de_acesso/logsAcessoStore.js";
import portaisStore from "../modules/configuracoes/portais/portaisStore.js";
import redeImobStore from "../modules/configuracoes/rede_imob/redeImobStore.js";
import perfisStore from "../modules/configuracoes/perfis_usuarios/perfisStore.js";
import formulariosStore from "../modules/configuracoes/formularios/formulariosStore.js";
import siteStore from "../modules/configuracoes/site/siteStore.js";

import alugueisAtrasadosStore from "../modules/widgets/alugueisAtrasados/alugueisAtrasadosStore.js";
import contratosAluguelVencidosStore from "../modules/widgets/contratosAluguelVencidos/contratosAluguelVencidosStore.js";
import ultimosImoveisVendaStore from "../modules/widgets/ultimosImoveisVenda/ultimosImoveisVendaStore.js";
import ultimosImoveisAluguelStore from "../modules/widgets/ultimosImoveisAluguel/ultimosImoveisAluguelStore.js";
import contasPagarDoDiaStore from "../modules/widgets/contasPagarDoDia/contasPagarDoDiaStore.js";
import contasPagarAtrasadasStore from "../modules/widgets/contasPagarAtrasadas/contasPagarAtrasadasStore.js";
import contasReceberDoDiaStore from "../modules/widgets/contasReceberDoDIa/contasReceberDoDiaStore.js";
import contasReceberAtrasadasStore from "../modules/widgets/contasReceberAtrasadas/contasReceberAtrasadasStore.js";

import alugueisDoDiaStore from '../modules/widgets/alugueisDoDia/alugueisDoDiaStore.js';
import contratosReajusteStore from '../modules/widgets/contratosReajuste/contratosReajusteStore.js';
import contratosRenovarStore from '../modules/widgets/contratosRenovar/contratosRenovarStore.js';

import assinaturaEletronicaStore from "../modules/configuracoes/assinaturaEletronica/assinaturaEletronicaStore.js";

import vistoriasStore from "../modules/alugueis/vistorias/vistoriasStore.js"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    isMobile: false
  },
  // MUTATIONS
  mutations: {
    showLoading(state) {
      state.loading = true;
    },
    hideLoading(state) {
      state.loading = false;
    },
    updateIsMobile(state, payload) {
      state.isMobile = payload;
    }
  },

  //ACTIONS
  actions: {
    showLoading(context) {
      context.commit("showLoading")
    },
    hideLoading(context) {
      context.commit("hideLoading")
    },
    updateIsMobile(context, payload) {
      context.commit("updateIsMobile", payload);
    }
  },
  modules: {
    imobiliariasStore: {
      namespaced: true,
      ...imobiliariasStore
    },
    dashboardStore: {
      namespaced: true,
      ...dashboardStore
    },
    caixaStore: {
      namespaced: true,
      ...caixaStore
    },
    administradorasStore: {
      namespaced: true,
      ...administradorasStore
    },
    bairrosStore: {
      namespaced: true,
      ...bairrosStore
    },
    caracteristicasStore: {
      namespaced: true,
      ...caracteristicasStore
    },
    cidadesStore: {
      namespaced: true,
      ...cidadesStore
    },
    boletosAvulsosStore: {
      namespaced: true,
      ...boletosAvulsosStore
    },
    condominiosStore: {
      namespaced: true,
      ...condominiosStore
    },
    contasBancariasStore: {
      namespaced: true,
      ...contasBancariasStore
    },
    placasStore: {
      namespaced: true,
      ...placasStore
    },
    parametrosStore: {
      namespaced: true,
      ...parametrosStore
    },
    logsAcessoStore: {
      namespaced: true,
      ...logsAcessoStore
    },
    portaisStore: {
      namespaced: true,
      ...portaisStore
    },
    redeImobStore: {
      namespaced: true,
      ...redeImobStore
    },
    perfisStore: {
      namespaced: true,
      ...perfisStore
    },
    formulariosStore: {
      namespaced: true,
      ...formulariosStore
    },
    siteStore: {
      namespaced: true,
      ...siteStore
    },
    alugueisAtrasadosStore: {
      namespaced: true,
      ...alugueisAtrasadosStore
    },
    contratosAluguelVencidosStore: {
      namespaced: true,
      ...contratosAluguelVencidosStore
    },
    ultimosImoveisVendaStore: {
      namespaced: true,
      ...ultimosImoveisVendaStore
    },
    ultimosImoveisAluguelStore: {
      namespaced: true,
      ...ultimosImoveisAluguelStore
    },
    alugueisClientesStore: {
      namespaced: true,
      ...alugueisClientesStore
    },
    alugueisContratosStore: {
      namespaced: true,
      ...alugueisContratosStore
    },
    alugueisImoveisStore: {
      namespaced: true,
      ...alugueisImoveisStore
    },
    alugueisRelatoriosStore: {
      namespaced: true,
      ...alugueisRelatoriosStore
    },
    baixasStore: {
      namespaced: true,
      ...baixasStore
    },
    remessasStore: {
      namespaced: true,
      ...remessasStore
    },
    registrosApiStore: {
      namespaced: true,
      ...registrosApiStore
    },
    controleRegistroApiStore: {
      namespaced: true,
      ...controleRegistroApiStore
    },
    dimobStore: {
      namespaced: true,
      ...dimobStore
    },
    parceriasStore: {
      namespaced: true,
      ...parceriasStore
    },
    vendasRelatoriosStore: {
      namespaced: true,
      ...vendasRelatoriosStore
    },
    vendasContratosStore: {
      namespaced: true,
      ...vendasContratosStore
    },
    vendasClientesStore: {
      namespaced: true,
      ...vendasClientesStore
    },
    vendasImoveisStore: {
      namespaced: true,
      ...vendasImoveisStore
    },
    vendasAtendimentosStore: {
      namespaced: true,
      ...vendasAtendimentosStore
    },
    usuariosStore: {
      namespaced: true,
      ...usuariosStore
    },
    loginStore: {
      namespaced: true,
      ...loginStore
    },
    // FINANCEIRO
    contasReceberStore: {
      namespaced: true,
      ...contasReceberStore
    },
    contasPagarStore: {
      namespaced: true,
      ...contasPagarStore
    },
    fornecedoresStore: {
      namespaced: true,
      ...fornecedoresStore
    },
    planosContaStore: {
      namespaced: true,
      ...planosContaStore
    },
    gruposContaStore: {
      namespaced: true,
      ...gruposContaStore
    },
    financeiroRelatoriosStore: {
      namespaced: true,
      ...financeiroRelatoriosStore
    },
    subGrupoPlanoContasStore: {
      namespaced: true,
      ...subGrupoPlanoContasStore
    },
    tipoContasStore: {
      namespaced: true,
      ...tipoContasStore
    },
    remessasBancariasFinanceiroStore: {
      namespaced: true,
      ...remessasBancariasFinanceiro
    },
    retornoBancarioFinanceiroStore: {
      namespaced: true,
      ...retornoBancarioFinanceiro
    },
    contasPagarDoDiaStore: {
      namespaced: true,
      ...contasPagarDoDiaStore
    },
    contasPagarAtrasadasStore: {
      namespaced: true,
      ...contasPagarAtrasadasStore
    },
    contasReceberDoDiaStore: {
      namespaced: true,
      ...contasReceberDoDiaStore
    },
    contasReceberAtrasadasStore: {
      namespaced: true,
      ...contasReceberAtrasadasStore
    },
    alugueisDoDiaStore: {
      namespaced: true,
      ...alugueisDoDiaStore
    },
    contratosReajusteStore: {
      namespaced: true,
      ...contratosReajusteStore
    },
    contratosRenovarStore: {
      namespaced: true,
      ...contratosRenovarStore
    },
    assinaturaEletronicaStore: {
      namespaced: true,
      ...assinaturaEletronicaStore
    },
    vistoriasStore: {
      namespaced: true,
      ...vistoriasStore
    }
  }
})
